export default __webpack_public_path__ + "static/fitness-app-cover-b1172964d5e70c8c3e0fe5932f3b6694.png";